export var PlanType;
(function (PlanType) {
    PlanType["BASIC"] = "BASIC";
    PlanType["PRO"] = "PRO";
    PlanType["ENTERPRISE"] = "ENTERPRISE";
})(PlanType || (PlanType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["CLIENT"] = "CLIENT";
    UserRole["WAITER"] = "WAITER";
    UserRole["KITCHEN"] = "KITCHEN";
    UserRole["BAR"] = "BAR";
    UserRole["RECEPTION"] = "RECEPTION";
    UserRole["VALET"] = "VALET";
    UserRole["HOSTESS"] = "HOSTESS";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["OWNER"] = "OWNER";
    UserRole["SUPERADMIN"] = "SUPERADMIN";
    UserRole["CORPORATE"] = "CORPORATE";
})(UserRole || (UserRole = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["REQUESTED"] = "REQUESTED";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["PREPARING"] = "PREPARING";
    OrderStatus["READY"] = "READY";
    OrderStatus["SERVED"] = "SERVED";
    OrderStatus["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    OrderStatus["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    OrderStatus["PAID"] = "PAID";
    OrderStatus["CANCELLED"] = "CANCELLED";
})(OrderStatus || (OrderStatus = {}));
export var ServiceTiming;
(function (ServiceTiming) {
    ServiceTiming["AS_THEY_COME"] = "AS_THEY_COME";
    ServiceTiming["ALL_TOGETHER"] = "ALL_TOGETHER";
    ServiceTiming["AT_THE_END"] = "AT_THE_END";
})(ServiceTiming || (ServiceTiming = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["CASH"] = "CASH";
    PaymentType["CARD"] = "CARD";
    PaymentType["MIXED"] = "MIXED";
    PaymentType["STRIPE"] = "STRIPE";
})(PaymentType || (PaymentType = {}));
export var TableType;
(function (TableType) {
    TableType["DINE_IN"] = "DINE_IN";
    TableType["TAKEOUT"] = "TAKEOUT";
    TableType["ROOM"] = "ROOM";
    TableType["SELF_CHECKOUT"] = "SELF_CHECKOUT";
})(TableType || (TableType = {}));
export var VenueType;
(function (VenueType) {
    VenueType["RESTAURANT"] = "RESTAURANT";
    VenueType["HOTEL"] = "HOTEL";
    VenueType["APARTMENT"] = "APARTMENT";
    VenueType["HOSPITAL"] = "HOSPITAL";
    VenueType["EVENT"] = "EVENT";
})(VenueType || (VenueType = {}));
export var PaymentMode;
(function (PaymentMode) {
    PaymentMode["IMMEDIATE"] = "IMMEDIATE";
    PaymentMode["ROOM_CHARGE"] = "ROOM_CHARGE";
})(PaymentMode || (PaymentMode = {}));
export var DishCategory;
(function (DishCategory) {
    DishCategory["APPETIZER"] = "APPETIZER";
    DishCategory["MAIN"] = "MAIN";
    DishCategory["DESSERT"] = "DESSERT";
    DishCategory["DRINK"] = "DRINK";
    DishCategory["SIDE"] = "SIDE";
})(DishCategory || (DishCategory = {}));
export var DishTag;
(function (DishTag) {
    DishTag["VEGAN"] = "VEGAN";
    DishTag["VEGETARIAN"] = "VEGETARIAN";
    DishTag["GLUTEN_FREE"] = "GLUTEN_FREE";
    DishTag["SPICY"] = "SPICY";
    DishTag["POPULAR"] = "POPULAR";
})(DishTag || (DishTag = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["PENDING"] = "PENDING";
    ReservationStatus["CONFIRMED"] = "CONFIRMED";
    ReservationStatus["SEATED"] = "SEATED";
    ReservationStatus["CANCELLED"] = "CANCELLED";
    ReservationStatus["NO_SHOW"] = "NO_SHOW";
})(ReservationStatus || (ReservationStatus = {}));
//# sourceMappingURL=enums.js.map